module.exports = __webpack_public_path__ + "static/img/btn.e9abf070.webp";